export default function SHOP_SEARCH(action) {
  const $searchForm = $(`
    <div class="p-search-form">
      <form action="${action}" method="GET" accept-charset="euc-jp">
        <div class="p-search-form__body">
          <input type="hidden" name="mode" value="srh">
          <div class="p-search-form__keyword-cell">
            <input type="text" name="keyword" placeholder="何かお探しですか？" class="p-search-form__keyword">
          </div>
          <div class="p-search-form__button-cell">
            <button type="submit" class="p-search-form__button">
              <svg class="p-search-form__icon" role="img" aria-hidden="true" aria-label="検索"><use xlink:href="/asset/svg/sprite.symbol.svg#icon-search"></use></svg>
            </button>
          </div>
        </div>
      </form>
    </div>
  `)
  window.load.header.then(() => {
    const $toggl = $('[data-plugin=shop_search_btn]')
    const init = () => {
      $('body').append( $searchForm.hide() )
      $toggl.on('click',e => {
        e.currentTarget.classList.toggle('active')
        $searchForm.fadeToggle().toggleClass('active')
        $('html,body').toggleClass('search-active')
      })
    }
    const close = () => {
      $toggl[0].classList.remove('active')
      $searchForm.fadeOut().removeClass('active')
      $('html,body').removeClass('search-active')
    }
    if( $toggl.length ) init()

    $(document).on('click touchend',e => {
      if ( !$(e.target).closest('[data-plugin=shop_search_btn]').length && !$(e.target).closest('.p-search-form__body').length)
        close()
    })
  })
}